@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  justify-content: space-between;
  width: auto;
  height: 300px;

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}

.rv-header-container {
  display: flex;
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
}

.rv-income-statements-chart-container {
  visibility: inherit;
  -webkit-font-smoothing: antialiased;
  color: rgb(0 0 0 / 87%);
  height: 90%;
  display: flex;
  margin-left: -10px;
  flex-direction: row;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    height: calc(90% + 5px);
  }
}

.rv-income-statements-chart-container #rv-income-statements-chart {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  @media screen and (max-width: 600px) {
    height: 90%;
  }
}

.rv-income-statements-chart-box {
  visibility: inherit;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: 600px) {
    position: relative;
    top: -20px;
    align-items: center;
  }
}

.rv-income-statements-chart-box-content {
  -webkit-font-smoothing: antialiased;
  color: rgb(0 0 0 / 87%);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: left;
}

.rv-income-statements-chart-text {
  visibility: inherit;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  color: #000d;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 700;
}

.rv-income-statements-chart-percentage {
  visibility: inherit;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  line-height: 1.5;
  display: flex;
  font-size: 14px;
  font-weight: 500;

  .rv-positive {
    color: $positive;
  }

  .rv-negative {
    color: $negative;
  }
}

.rv-legend {
  display: flex;
  flex-direction: column;
  margin-top: -3px;
}

.rv-legend-value {
  font-size: 14px;
  color: #070a0e;
}

.rv-legend-name {
  font-size: 12px;
  font-weight: normal;
  color: #424242;
  white-space: normal;
}
